/**
 * Broker Parser Configs Index
 * Registry of all broker configurations for the generic parser
 */

import { Broker } from '@shared/index';
import { BrokerParserConfig } from '../types';
import { iciciDirectConfig } from './iciciDirect';

// Registry of all broker configs
const CONFIG_REGISTRY: Partial<Record<Broker, BrokerParserConfig>> = {
  [Broker.ICICI_DIRECT]: iciciDirectConfig,
  // Add more brokers here as they are implemented:
  // [Broker.DHAN]: dhanConfig,
  // [Broker.UPSTOX]: upstoxConfig,
};

/**
 * Get parser config for a broker
 * @throws Error if broker config not found
 */
export function getParserConfig(broker: Broker): BrokerParserConfig {
  const config = CONFIG_REGISTRY[broker];
  if (!config) {
    throw new Error(`No parser config found for broker: ${broker}`);
  }
  return config;
}

/**
 * Check if a broker has a generic parser config available
 */
export function hasParserConfig(broker: Broker): boolean {
  return broker in CONFIG_REGISTRY;
}

/**
 * Get list of brokers that use the generic parser (ISIN lookup flow)
 */
export function getBrokersWithGenericParser(): Broker[] {
  return Object.keys(CONFIG_REGISTRY) as Broker[];
}

export { iciciDirectConfig };
